import { VisuallyHidden } from '@farol-ds/react'
import { forwardRef, SVGProps } from 'react'

import { paymentIconLabelMapping, paymentIconMapping, PaymentIconMethods } from './constants'

export type PaymentIconElement = SVGSVGElement
export type PaymentIconMethod = (typeof PaymentIconMethods)[number]

export interface PaymentIconProps extends SVGProps<PaymentIconElement> {
  method: PaymentIconMethod
}

export const PaymentIcon = forwardRef<PaymentIconElement, PaymentIconProps>(function PaymentIcon(
  props,
  forwardedRef
) {
  const { method, ...rest } = props

  const SvgComponent = paymentIconMapping[method]
  if (!SvgComponent) return null

  const label = paymentIconLabelMapping[method]

  return (
    <>
      <SvgComponent
        data-testid="payment-icon-icon"
        aria-hidden="true"
        width="100%"
        height="100%"
        {...rest}
        ref={forwardedRef}
      />
      {label && <VisuallyHidden>{label}</VisuallyHidden>}
    </>
  )
})

export * from './constants'
